import React from 'react';
import PropTypes from 'prop-types';

const Button = ({
  type,
  label,
  ariaLabel,
  href,
  disabled,
  btnClassName,
  size,
  className,
  ...props
}) => {
  const buttonClasses = `
    btn btn--${btnClassName}
    ${size === 'small' && 'btn--small'}
    ${type === 'link' && disabled && 'btn--disabled'}
    ${className}
  `;

  return type === 'link' ? (
    <a href={href} aria-label={ariaLabel} className={buttonClasses} {...props}>
      {label}
    </a>
  ) : (
    <button
      {...{ type, disabled }}
      aria-label={ariaLabel}
      className={buttonClasses}
      {...props}
    >
      {label}
    </button>
  );
};

Button.propTypes = {
  label: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string,
  href: PropTypes.string,
  type: PropTypes.oneOf(['link', 'submit', 'button']).isRequired,
  size: PropTypes.oneOf(['large', 'small']),
  btnClassName: PropTypes.oneOf(['primary', 'secondary', 'outline']).isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string
};

Button.defautProps = {
  href: '',
  disabled: false,
  size: 'large'
};

export default Button;
